import { render } from "./HeaderUserAvatar.vue?vue&type=template&id=85a9e7e0&scoped=true"
import script from "./HeaderUserAvatar.vue?vue&type=script&lang=js"
export * from "./HeaderUserAvatar.vue?vue&type=script&lang=js"

import "./HeaderUserAvatar.vue?vue&type=style&index=0&id=85a9e7e0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a9e7e0"]])

export default __exports__